import styled from 'styled-components';
import get from 'lodash/get';
import { StyledChipProps } from './types';

export const backgroundColorOptions = {
  warning: 'support.orange.background',
  success: 'success.background.weak',
  info: 'support.blue.background',
};

export const textColorOptions = {
  warning: 'support.orange.base',
  success: 'success.text.strong',
  info: 'support.blue.base',
};

export const Chip = styled.div<StyledChipProps>`
  color: ${({ theme, $type }) => get(theme, textColorOptions[$type])};
  background-color: ${({ theme, $type }) =>
    get(theme, backgroundColorOptions[$type])};
  border-radius: ${({ theme }) => theme.border.radius.medium};
  padding: ${({ theme }) => theme.spacing.km0}
    ${({ theme }) => theme.spacing.km2};
  text-transform: uppercase;
  letter-spacing: -0.03em;
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: ${({ theme }) => theme.font.lineHeight.large};
  font-size: ${({ theme }) => theme.font.size.m1};
  width: fit-content;
  height: fit-content;
`;
